<div class="staticcontainer">
    <div class="scrollcontainer">
        <div *ngFor="let floorContainer of floorContainerList" class="container-item">
            <div *ngIf="floorContainer.type === 'ClassContainer'">
                <h3>Class area boundaries</h3>
            </div>
            <div *ngIf="floorContainer.type === 'BackgroundContainer'">
                <h3>Background Image</h3>
            </div>
            <div *ngFor="let groupItem of floorContainer.childs">
                <span *ngIf="floorContainer.type === 'ClassContainer'; else classContainerBlock" class="item">
                    <b>{{groupItem.name}}</b>
                    <span *ngIf="!groupItem.editorObject.isClassVisible();else notVisibleClass">
                        <button mat-icon-button matTooltip="Show class area" [matRippleDisabled]="true"
                            (click)="toggleClassContainer(groupItem)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </span>
                    <ng-template #notVisibleClass>
                        <button mat-icon-button matTooltip="Hide class area" [matRippleDisabled]="true"
                            (click)="toggleClassContainer(groupItem)">
                            <mat-icon>visibility_off</mat-icon>
                        </button>
                    </ng-template>
                </span>
                <ng-template #classContainerBlock>
                    <span class="item">
                        <b>{{groupItem.name}}</b>
                        <span>
                            <input type="file" class="file-input" (change)="onFileSelected($event,groupItem)"
                                #fileUpload>
                            <button mat-icon-button matTooltip="Upload image" [matRippleDisabled]="true"
                                (click)="fileUpload.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <button *ngIf="!groupItem.editorObject.isBackgroundVisible();else notVisibleBackground"
                                mat-icon-button matTooltip="Show background image" [matRippleDisabled]="true"
                                (click)="toggleBackgroundImageContainer(groupItem)"
                                [disabled]="groupItem.editorObject.isDefaultImage()">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </span>
                        <ng-template #notVisibleBackground>
                            <button mat-icon-button matTooltip="Hide background image"
                                (click)="toggleBackgroundImageContainer(groupItem)" [matRippleDisabled]="true"
                                [disabled]="groupItem.editorObject.isDefaultImage()">
                                <mat-icon>visibility_off</mat-icon>
                            </button>
                        </ng-template>
                    </span>
                    <div class="slider-control">
                        <span><b>Opacity</b></span>
                        <mat-slider class="slider" [min]="0.00" [max]="1.00" [step]="0.01" showTickMarks discrete
                            [displayWith]="formatLabel">
                            <input type="range" [disabled]="groupItem.editorObject.isDefaultImage()"
                                [ngModel]="groupItem.editorObject.opacity()"
                                (ngModelChange)="opacityChanged($event,groupItem)" matSliderThumb>
                        </mat-slider>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>